import React from 'react'

import { string, shape, array, bool, object, arrayOf, number } from 'prop-types'

import Hamburger from './Components/Hamburger/Hamburger'
import Logo from './Components/Logo/Logo'
import Menu from './Components/Menu/Menu'
import MobileCurtains from './Components/MobileCurtains/MobileCurtains'
import Search from './Components/Search/Search'
import UserActions from './Components/UserActions/UserActions'
import { useHamburgerStatus } from './Hooks/useHamburgerStatus'

function Navigation({
  commonRoutes,
  mainMenuItems,
  communityLinks,
  actionsLinks,
  actionsConfig,
  locale,
  cldGiftSize,
  isInListingPage,
  searchInputValue = '',
  printableCategories,
  assetCategories,
  enableAdvancedKeywordsSearch = false,
  extractingCoreStyles = false,
  searchPlaceholder,
  byType,
  budgetsData,
}) {
  const { root } = commonRoutes
  const { isActive, toggleHamburger } = useHamburgerStatus()

  return (
    <div className="wayfinder__container">
      <Hamburger isActive={isActive} toggle={toggleHamburger} />
      <Logo url={root} isCurrentUser={actionsConfig?.isCurrentUser} />
      <Search
        locale={locale}
        isInListingPage={isInListingPage}
        searchInputValue={searchInputValue}
        enableAdvancedKeywordsSearch={enableAdvancedKeywordsSearch}
        searchPlaceholder={searchPlaceholder}
      />
      <Menu
        isActive={isActive}
        mainMenuItems={mainMenuItems}
        communityLinks={communityLinks}
        assetCategories={assetCategories}
        printableCategories={printableCategories}
        extractingCoreStyles={extractingCoreStyles}
        byType={byType}
        locale={locale}
        budgetsData={budgetsData}
        actionsConfig={actionsConfig}
      />
      <UserActions
        actionsLinks={actionsLinks}
        actionsConfig={actionsConfig}
        locale={locale}
        cldGiftSize={cldGiftSize}
      />
      <MobileCurtains isActive={isActive} toggle={toggleHamburger} />
    </div>
  )
}

Navigation.propTypes = {
  commonRoutes: object.isRequired,
  mainMenuItems: object.isRequired,
  communityLinks: array.isRequired,
  actionsLinks: arrayOf(shape({
    id: string,
    href: string,
    icon: string,
    data: shape({
      trackText: string,
      trackLabel: string,
      avoidNavigation: bool,
    }),
  })).isRequired,
  actionsConfig: shape({
    cart: object,
    inboxSize: number,
    isCurrentUser: bool,
    newRoyaltyUi: bool,
    showCartAds: bool,
  }).isRequired,
  locale: string.isRequired,
  isInListingPage: bool.isRequired,
  printableCategories: object.isRequired,
  searchInputValue: string,
  cldGiftSize: string.isRequired,
  searchPlaceholder: string.isRequired,
  assetCategories: object.isRequired,
  enableAdvancedKeywordsSearch: bool,
  extractingCoreStyles: bool,
  byType: arrayOf(shape({
    icon: string,
    name: string,
    path: string,
  })).isRequired,
  budgetsData: shape({
    assetsBaseUrl: string.isRequired,
    printableBaseUrl: string.isRequired,
    assetsBudgets: arrayOf(shape({
      title: string.isRequired,
      path: string.isRequired,
      icon: string.isRequired,
    })).isRequired,
    printableAssetsBudgets: arrayOf(shape({
      title: string.isRequired,
      path: string.isRequired,
      icon: string.isRequired,
    })).isRequired,
  }).isRequired,
}

export default Navigation
